// extracted by mini-css-extract-plugin
export var layoutContainer = "_5u-0";
export var layoutContainerNoRounding = "_5u-6";
export var layoutContainerOpen = "_5u-5";
export var layoutContainerResizing = "_5u-1";
export var mainContent = "_5u-2";
export var resizeDivider = "_5u-3";
export var slidePanel = "_5u-4";